const inject = ['$stateParams', '$uibModal', 'shipmentService', 'paymentService', '$state', '$document'];

function EditPaymentModal($stateParams, $uibModal, shipmentService, paymentService, $state, $document) {
  this.open = function() {
    const modal = $uibModal.open({
      template: '<div ui-view="billing" aria-live="assertive" aria-atomic="true"></div>',
      backdrop: true,
      windowTopClass: 'og-billing-edit',
      ariaLabelledBy: 'og-billing-modals-title'
    });

    modal.rendered.then(() => $document[0].querySelector('.og-modal-window').setAttribute('aria-modal', true));

    return modal.result
      .then(
        () => $state.go('root', {}, { reload: true }),
        () => $state.go('root')
      );
  };

  this.submit = function(selectedId, useForAll) {
    if (useForAll) {
      return paymentService.useForAll(selectedId);
    }
    return shipmentService.setPaymentForSubscriptions($stateParams.shipment, selectedId);
  };
}

EditPaymentModal.$inject = inject;

module.exports = EditPaymentModal;
